<div class="content-with-filled-button">
    <h1 class="title">{{copyService.copies.credit_info.title}}</h1>
    <div class="row">
        <div class="col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <div class="box-input">
                <form id="formMeses" [formGroup]="formGroup">
                    <voxel-form-field [id]="'input-value-city'" class="input"
                        [label]="copyService.copies.credit_info.label_type" [formGroup]="formGroup"
                        msgErr="Campo obligatorio">
                        <vcl-autocomplete id="autoCompleteComponent"
                            [placeholder]="copyService.copies.credit_info.placeholder_type"
                            (change)="selectOption($event)" required formControlName="input-value-credit" ngDefaultControl>
                            <vcl-option [id]="'id'" *ngFor="let option of options" [value]="option">
                                {{ option.id + ' ' + option.name }}
                            </vcl-option>
                        </vcl-autocomplete>
                    </voxel-form-field>
                </form>
                <form id="formMeses" [formGroup]="formGroup">
                    <vcl-form-field class="input" label="{{copyService.copies.credit_info.label_number_credit}}"
                        [msgErr]="copyService.copies.credit_info.validation_length">
                        <input vclInput placeholder="{{copyService.copies.credit_info.placeholder_numer_credit}}"
                            id="inputValueMeses" maxlength="11" (input)="onInputNumber($event)"
                            formControlName="number" ngDefaultControl>
                    </vcl-form-field>
                </form>
                <form id="formMeses" [formGroup]="formGroup">
                    <vcl-form-field class="input" label="{{ copyService.copies.credit_info.label_balance_credit}}"
                        [msgErr]="copyService.copies.credit_info.validation_required">
                        <input vclInput appDecimal
                            placeholder="{{copyService.copies.credit_info.placeholder_balance_credit}}"
                            id="inputValueMeses" formControlName="amount" ngDefaultControl>
                    </vcl-form-field>
                </form>
            </div>
            <vcl-button id="button-contextual-resend" class="border" *ngIf="editCredit" label="Eliminar crédito"
                (click)="deleteCredit()" buttonType="contextual" [disableRipple]="true">
            </vcl-button>
        </div>
    </div>
</div>
<!-- {{index}} -->
<app-controls id="docIntroBtns" [hasPrevious]="true"
    [nextLabel]="editCredit ? copyService.copies.credit_info.save_button : copyService.copies.credit_info.add_button"
    (next)="next()" (only_previous)="back()" [nextDisabled]="!formGroup.valid">
</app-controls>